/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import PropTypes from 'prop-types';
import i18n from '../../i18n';

// Component imports
import { Tag } from 'antd';
import { CheckOutlined, ClockCircleOutlined, ExclamationOutlined, UserOutlined } from '@ant-design/icons';
import { TransferredIncomingIcon, TransferredOutgoingIcon } from '../Icons/TransferredIcon';
import { AgentAcceptIcon } from '../Icons/AgentAcceptIcon';

const getTagProps = (type) => {
  switch (type) {
    case 'transfer':
      return {
        icon: <TransferredOutgoingIcon />,
        color: 'orange',
        title: i18n.t('Transfer')
      };

    case 'transferred':
      return {
        icon: <TransferredIncomingIcon />,
        color: 'orange',
        title: i18n.t('Transferred')
      };

    case 'joined':
      return {
        icon: <UserOutlined />,
        color: 'blue',
        title: i18n.t('Joined')
      };

    case 'active':
      return {
        icon: <svg height="1em" width="1em"><circle cx="5px" cy="7px" r="3px" fill="currentColor" /></svg>,
        color: 'success',
        title: i18n.t('Active')
      };

    case 'new':
      return {
        icon: <ExclamationOutlined />,
        color: 'red',
        title: i18n.t('New')
      };

    case 'finished':
      return {
        icon: <CheckOutlined className="fs-xs" />,
        color: 'default',
        title: i18n.t('Finished')
      };

    case 'missed':
      return {
        icon: <ClockCircleOutlined />,
        color: 'default',
        title: i18n.t('Missed')
      };

    case 'accepted':
      return {
        icon: <AgentAcceptIcon />,
        color: 'processing',
        title: i18n.t('Accepted')
      };

    default:
      return {
        color: 'default',
        icon: undefined,
        title: type
      };
  }
};

const ConversationStatusTag = (props) => {
  const { type, className = '', title, ...restProps } = props;
  const tagProps = getTagProps(type);

  return (
    <Tag color={tagProps.color} icon={tagProps.icon} className={`ant-tag-sm ${className}`} {...restProps}>
      {title || tagProps.title}
    </Tag>
  );
};

ConversationStatusTag.propTypes = {
  type: PropTypes.oneOf(['transfer', 'transferred', 'joined', 'active', 'new', 'finished', 'missed', 'accepted']),
  title: PropTypes.string,
  className: PropTypes.string
};

export default ConversationStatusTag;
